<script setup lang="ts">
const { completedSteps, steps } = useHumanRiskOnboardingProgress()
</script>

<template>
  <NuxtLayout name="onboarding-base">
    <HumanRiskOnboardingLayoutTopBar>
      <ProgressIndicator :steps :completed-steps />
    </HumanRiskOnboardingLayoutTopBar>
    <div class="z-1 flex w-full max-w-6xl flex-col p-6 sm:p-10">
      <slot />
    </div>
  </NuxtLayout>
</template>
